import storage, { sessionStorage } from 'util/storage';

let storeInLocalStorage = false;

const setStoreInLocalStorage = isStore => {
	storeInLocalStorage = isStore;
};

export const detectAuthStorageSupport = () => {
	if (storage.getItem('token') !== null) {
		setStoreInLocalStorage(true);
		sessionStorage.removeItem('token');
	}
};

const setToken = value => {
	if (storeInLocalStorage) {
		storage.setItem('token', value);
		return;
	}

	sessionStorage.setItem('token', value);
};

const getToken = () => {
	if (storeInLocalStorage) {
		return storage.getItem('token');
	}

	return sessionStorage.getItem('token');
};

const removeToken = () => {
	if (storeInLocalStorage) {
		storage.removeItem('token');
		return;
	}

	sessionStorage.removeItem('token');
};

export default {
	setToken,
	getToken,
	removeToken,
	setStoreInLocalStorage,
};



// WEBPACK FOOTER //
// ./src/util/authStorage.js